<template>
  <ul class="tags">
    <li v-for="tag in tags" :key="tag.id" :class="active ? 'tag active' : 'tag'">
      <a v-if="type" :href="'/tags/' + tag.id + '?type=seminars'">
        {{ tag.name }}
      </a>
      <a v-else :href="'/tags/' + tag.id">
        {{ tag.name }}
      </a>
    </li>
  </ul>
</template>

<script>
  export default {
    props: [
      'tags',
      'active',
      'type',
    ],
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  @value breakpoint: (min-width: 1000px);
  .tags{display:flex;flex-wrap:wrap;padding-left: 0;overflow: hidden;max-height:2rem;
    .tag{list-style-type: none;margin-right:5px;padding:3px 8px;font-size: 0.9rem;background:cBaseDk(40);margin-bottom: 5px;color: $cText;font-family: $font-family-sans-serif;
      &:hover{cursor:pointer;}
      &.active{color:white;background: $cBaseDk;}
      a {color: white;}
    }
  }
</style>
